import {
  Command,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { Check, ChevronDown } from "lucide-react";
import { useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { Button } from "./ui/button";

const DebounceSearch = ({
  items,
  searchPlaceholder = "Search item...",
  selectItemMsg = "Select an item",
  onSearchChange,
  value,
  selected = [],
  onSelect,
}) => {
  const [open, setOpen] = useState(false);

  const handleOnSearchChange = useDebouncedCallback((e: string) => {
    onSearchChange?.(e.toLocaleLowerCase());
  }, 300);
  function setOpenState(isOpen: boolean) {
    if (!isOpen) handleOnSearchChange("");
    setOpen(isOpen);
  }

  return (
    <Popover open={open} onOpenChange={setOpenState} modal={true}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between h-fit p-0 bg-transparent"
        >
          <span className="truncate flex items-center">
            {value || selectItemMsg}
          </span>
          <ChevronDown className={`ml-auto ${open && "rotate-180"}`} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full min-w-[23rem]">
        <Command shouldFilter={false}>
          <div
            className="flex items-center 
             border-border p-2 border-[1px] rounded gap-2 w-full
            "
          >
            <CommandInput
              placeholder={searchPlaceholder}
              className="placeholder:text-gray-70 outline-none  p-0 border-none rounded  bg-transparent h-fit w-full border-0"
              onValueChange={handleOnSearchChange}
            />
          </div>

          <CommandList className="w-full">
            {items.map((item) => {
              const isSelected =
                value === item.value || selected.includes(item.value);
              return (
                <CommandItem
                  className={`p-2 text-sm cursor-pointer hover:bg-sky-600 hover:text-white rounded 
                      `}
                  key={item.value}
                  value={item.value}
                  keywords={[item.label]}
                  onSelect={(value) => {
                    onSelect(value, item.label);
                    setOpen(false);
                  }}
                  disabled={isSelected}
                >
                  {item.label}
                  <Check
                    className={cn(
                      "ml-auto h-4 w-4",
                      isSelected ? "opacity-100" : "opacity-0"
                    )}
                  />
                </CommandItem>
              );
            })}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default DebounceSearch;
